export const GLOBAL_ENVIRONMENT = "v1/global/environment";

/**
 * @Auth
 */
export const LOGIN = "v1/auth/web-login";
export const REGISTER = "v1/auth/register";
export const FORGOT_PASSWORD = "v1/auth/forgot-password";
export const RESET_PASSWORD = "v1/auth/reset-password";
export const VERIFY_2FA = "v1/auth/verify-2fa";
export const REGENERATE_2FA = "v1/auth/regenerate-2fa-code";
export const REFRESH_TOKENS_API = "v1/auth/refresh-tokens";
/**
 * @Admin_Profile
 */
export const ADMIN_PROFILE = "v1/account/profile";
export const CHANGE_PASSWORD = "v1/account/change-password";
/**
 * @Admin_users
 */
export const ADMIN_USERS_LIST = "v1/users";
export const ADMIN_USER_ADD = "v1/users";
export const ADMIN_USER_EDIT = "v1/users/";
export const ADMIN_USER_DELETE = "v1/users/";
export const ADMIN_USER_CHANGE_STATUS = "v1/users/change-status/";
export const ADMIN_USER_GENERATE_QR = "v1/users/qr/";
/**
 * @app_channels
 */
export const CHANNELS_LIST = "v1/channels";
export const CHANNELS_ADD = "v1/channels";
export const CHANNELS_EDIT = "v1/channels/";
export const CHANNELS_DETAILS = "v1/channels/";
export const CHANNELS_DELETE = "v1/channels/";
export const CHANNELS_MEMBERS = "v1/channels/";
export const CHANNELS_ACTIVITY = "v1/channels/";
export const CHANNELS_ASSIGN = "v1/channels/assign";
export const CHANNELS_UNASSIGN = "v1/channels/unassign";
/**
 * @admin_departments
 */
export const DEPARTMENTS_LIST = "v1/departments";
export const DEPARTMENT_ADD = "v1/departments";
export const DEPARTMENT_EDIT = "v1/departments/";
export const DEPARTMENT_DELETE = "v1/departments/";
export const DEPARTMENT_DETAILS = "v1/departments/";
export const DEPARTMENT_CHANGE_STATUS = "v1/departments/";
/**
 * @app_channels
 */
export const STORES_LIST = "v1/stores";
export const STORE_ADD = "v1/stores";
export const STORE_EDIT = "v1/stores/";
export const STORE_DELETE = "v1/stores/";
export const STORE_DETAILS = "v1/stores/";
/**
 * @FAQ
 */
export const FAQ_LIST = "v1/faqs";
export const FAQ_EDIT = "v1/faqs/";
/**
 * @CMS
 */
export const CMS_LIST = "v1/cms_pages";
export const CMS_ADD = "v1/cms_pages";
export const CMS_EDIT = "v1/cms_pages/"; // +id
export const CMS_DETAILS = "v1/cms_pages/"; // +id
export const CMS_DELETE = "v1/cms_pages/"; // +id
/**
 * @ROLES_AND_PERMISSION
 */
export const ROLES = "v1/roles";
export const ROLES_LIST = "v1/roles/roles-list";
export const ROLES_AND_PERMISSION = "v1/roles/roles-permission";

export const ENQUIRY = "v1/enquiry";

/**
 * @app_alerts
 */
export const ALERTS_LIST = "v1/alerts";
export const ALERT_ADD = "v1/alerts";
export const ALERT_EDIT = "v1/alerts/";
export const ALERT_DETAILS = "v1/alerts/";
export const ALERT_DELETE = "v1/alerts/";

// Contact Query (Admin)
export const CONTACT_QUERY_LIST = "v1/contact_queries";
export const CONTACT_QUERY_DETAIL = "v1/contact_queries/"; // +id
export const CONTACT_QUERY_DELETE = "v1/contact_queries/"; // +id

// Countries (Admin)
export const COUNTRIES_LIST = "v1/countries";
// Provinces (Admin)
export const PROVINCES_LIST = "v1/provinces";
// Cities (Admin)
export const CITIES_LIST = "v1/cities";

export const SETTINGS_GET = "v1/global/settings";
export const SETTING_UPDATE = "v1/global/settings/";
